<template>
  <div>
    <div class="headerFiltle">
      <div class="headFileitem">
        <div class="BrandSel" @click.stop="showBrand($event)">
          <span style="margin-left:10px;margin-right:5px">品牌:</span>
          <p>{{brand}}</p>
          <i class="el-icon-arrow-down" style="margin-right:10px"></i>
        </div>
        <div class="BrandSel" style="z-index:99999" @click="hideOther($event)">
          <el-date-picker
            v-model="endTime"
            type="month"
            placeholder="请选择月"
            :editable="false"
            :clearable="false"
            style="width:100px"
            format="yyyy-MM"
            value-format="yyyyMM"
            :picker-options="pickerOptions"
            @change="changeMonth"
          ></el-date-picker>
        </div>
      </div>
      <div class="headerHistory" v-show="BrandFlag">
        <span class="history_tie" style="background: transparent;">选择品牌:</span>
        <span
          v-for="item in option1"
          :key="item.value"
          class="history_tie"
          :class="{history_Active:item.text==brand}"
          @click.stop="changeValue(item.text)"
        >{{item.text}}</span>
      </div>
    </div>
    <div class="main">
      <div class="conTit" style="margin:10px 0">
        <span></span>
        <p>{{selCateGory1Cn}} 风格榜</p>
        <!-- <img
          src="../../assets/jpg/showBtn.png"
          @click="changeindustryMsg()"
          style="width:20px;height:20px;margin-left:8px"
          alt
        /> -->
        <div  class="industryMsg" v-html="industryMsg"></div>
        <p class="conTitAb" @click="changeFlag()">
          <!-- <b :class="{conTitAbAct:MtYFlag}">年度数据</b>
          <b :class="{conTitAbAct:!MtYFlag}">月度数据</b>-->
        </p>
      </div>
      <!-- <p style="font-size:8px;color:#494949;margin-top:5px">
        *竞品，竞品牌分析即将到来！由于2019年数据不全，请谅解本页GMV
        <i class="el-icon-top"></i>于2020年8月以后开始更新.
      </p> -->
      <div class="StyleList">
        <ul>
          <li
            class="listItem"
            v-for="item in listStyleList"
            :key="item.storeType"
            :class="{industry_footAct:item.storeType==selCateGory2}"
            @click="SelCateGory2(item.storeType)"
          >
            <div :class="{sanjiao:item.storeType==selCateGory2}"></div>
            <span>{{item.storeType}}</span>
            <div class="listMoney">
              <h4>￥{{item.salesEn}}</h4>
              <p>平均GMV</p>
            </div>
            {{item.growth}}
            <el-icon :class="parseInt(item.growth)>0?'el-icon-top-right listItemIcon':'el-icon-bottom-right listItemIcon'"></el-icon>
            <div class="listItemRate"></div>
          </li>
        </ul>
      </div>
      <div style="margin-top:15px;width:100%;display:flex">
        <div class="listSel">
          <p>竞争类型:</p>
          <van-dropdown-menu active-color="#CC4545" :overlay="false">
            <van-dropdown-item
              v-model="value"
              :options="ConsumerPerTable"
              @change="changeType(value-0)"
            />
          </van-dropdown-menu>
        </div>
        <div class="listSel2">
          <p>榜单:</p>
          <van-dropdown-menu active-color="#CC4545" :overlay="false">
            <van-dropdown-item
              v-model="value2"
              :options="TopList"
              @change="changeTop(value2)"
              class="right"
            />
          </van-dropdown-menu>
        </div>
      </div>
      <ul class="SkuTable">
        <li v-for="(item,i) in listStyleTable" :key="item.shopInfo">
          <el-row :gutter="4" type="flex" align="middle" style="text-align:center">
            <el-col :span="3" :class="i<1?'table_top':i>=2?' table_bot':' table_mid'">No.{{i+1}}</el-col>
            <el-col :span="5">
              <div class="grid-content bg-purple" style="text-align:left">
                <span>{{item.shopInfo}}</span>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="SkuTableList">
                  <span>GMV</span>
                  <p>{{item.salesEn}}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple">
                <div class="SkuTableList">
                  <span>
                    GMV
                    <i class="el-icon-top"></i>
                  </span>
                  <p>{{item.growth}}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="SkuTableList">
                  <span>流量</span>
                  <p>{{item.visitorsEn}}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="SkuTableList">
                  <span>转化</span>
                  <p>{{item.paymentRate}}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="SkuTableList">
                  <span>客单价</span>
                  <p>{{parseInt(item.unitPrice)}}</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </li>
      </ul>

      <div class="conTit" style="margin:10px 0">
        <span></span>
        <p>{{selCateGory2}} 竞争对比</p>
        <p class="conTitAb" @click="changeFlag()">
          <!-- <b :class="{conTitAbAct:MtYFlag}">年度数据</b>
          <b :class="{conTitAbAct:!MtYFlag}">月度数据</b>-->
        </p>
      </div>

      <div class="ConsumerPer">
        <span
          v-for="(item,i) in ConsumerPerTable"
          :key="item.attr"
          :class="{ConsumerPer_act:i+1==value}"
          :attr="item.attr"
          @click="changeType(item.value-0)"
        >{{item.text}}</span>
      </div>

      <CompeteMap></CompeteMap>
      <div></div>
    </div>
  </div>
</template>
<script>
import CompeteMap from "../ButFo_Radar/public/CompeteMap";
import qs from "qs";
import { mapState } from "vuex";

export default {
  data() {
    return {
      industryMsg: '',
      industryMsgFlag: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7 - 2592000000;
        },
      },
      value: 1,
      ConsumerPerTable: [
        { text: "竞店", value: 1, attr: "竞店" },
        // { text: "竞品牌", value: 2, attr: "竞品牌" },
        { text: "竞品", value: 3, attr: "竞品" },
      ],
      value2: "a",
      TopList: [
        { text: "销量榜", value: "a", attr: "销量榜" },
        { text: "飙升榜", value: "b", attr: "飙升榜" },
      ],
      brand: "",
      endTime: "",
      startTime: "",
      selCateGory1Cn: "",
      selCateGory1: "",
      selCateGory2: "",
      listStyleList: [],
      listStyleTable: [],
      BrandFlag: false,
      option1: [],
      MtYFlag: false,
      BrandList: [],
    };
  },
  methods: {
    changeindustryMsg() {
      this.industryMsgFlag = !this.industryMsgFlag;
    },
    changeType(value) {
      this.value = value;
      this.$store.dispatch("getCouCateGory1", this.value);

    },
    changeTop() {},
    changeMonth(data) {
      this.$store.dispatch("getCouMonthTo", data);
    },
    changeFlag() {
      this.MtYFlag = !this.MtYFlag;
      this.getMonth();
    },
    showBrand(e) {
      if ($(e.currentTarget).attr("class") == "BrandSel") {
        $(e.currentTarget).addClass("industry_footAct");
      } else {
        $(e.currentTarget).removeClass("industry_footAct");
      }
      $(e.currentTarget).siblings(".BrandSel").removeClass("industry_footAct");
      this.BrandFlag = !this.BrandFlag;
    },
    changeValue(text) {
      this.brand = text;
      this.$store.dispatch("getCouBrand", this.brand);
      this.getStyleList();
      this.BrandFlag = false;
    },
    hideOther(e) {
      if ($(e.currentTarget).attr("class") == "BrandSel") {
        $(e.currentTarget).addClass("industry_footAct");
      } else {
        $(e.currentTarget).removeClass("industry_footAct");
      }
      this.BrandFlag = false;
    },
    getBrand() {
      this.$addr
        .get("/radar/getCompeteBrand")
        .then((res) => {
          this.option1 = [];
          this.BrandList = [];
          this.BrandList = res.data.data;
          this.BrandList.map((item, index) => {
            this.option1.push(
              Object.assign({}, item, {
                text: item.brandNameEn,
                value: item.brandNameEn,
              })
            );
          });
          this.brand = this.BrandList[1].brandNameEn;
          this.$store.dispatch("getCouBrand", this.brand);
          this.getMonth();
        })
        .catch((error) => {
          this.$toast("接收数据中");
        });
    },
    getMonth() {
      this.$addr
        .post("/radar/getUpdateDate")
        .then((res) => {
          if (this.MtYFlag) {
            this.startTime = 0;
          } else {
            this.startTime = 1;
          }
          this.endTime = res.data.data[0].competeYyyymm;
          this.$store.dispatch("getCouMonthFrom", this.startTime);
          this.$store.dispatch("getCouMonthTo", this.endTime);
          this.getStyleList();
        })
        .catch((error) => {
          this.$toast("接收数据中");
        });
    },
    getStyleList() {
      this.$addr
        .post(
          "/radar/getCompeteStyle",
          qs.stringify({
            isMonthType: this.startTime,
            yyyyMM: this.endTime,
            brand: this.brand,
            competeType: this.value,
          })
        )
        .then((res) => {
          this.listStyleList = res.data.data;
          this.selCateGory2 = res.data.data[0].storeType;
          this.$store.dispatch("getCouCateGory2", this.selCateGory2);
        })
        .catch((error) => {
          this.$toast("接收数据中");
        });
    },
    SelCateGory2(value) {
      this.selCateGory2 = value;
      this.$store.dispatch("getCouCateGory2", this.selCateGory2);
    },
    getStyleListTable() {
      this.$addr
        .post(
          "/radar/getTopCompete",
          qs.stringify({
            isMonthType: this.startTime,
            yyyyMM: this.endTime,
            brand: this.brand,
            storeType: this.selCateGory2,
            competeType: this.value,
          })
        )
        .then((res) => {
          this.listStyleTable = res.data.data;
        })
        .catch((error) => {
          this.$toast("接收数据中");
        });
    },
  },
  components: {
    CompeteMap,
  },
  computed: {
    ...mapState([
      "CoumonthFrom",
      "CoumonthTo",
      "CouBrand",
      
      "CouCateGory2",
      "CouCateGory1",
    ]),
  },
  watch: {
    CouCateGory2(currVal) {
      this.setOneGet();
    },
    CoumonthTo(currVal) {
      this.getStyleList();
      this.getStyleListTable();
    },
    CouCateGory1(currVal){
      this.getStyleList();
    }
  },
  mounted() {},
  created() {
    this.getBrand();
    let _ = require("lodash");
    this.setOneGet = _.debounce(this.getStyleListTable, 500);
  },
};
</script>
<style scoped>
.industryMsg {
   position: absolute;
  /* min-width: 100px; */
  min-height: 10px;
  background:rgb(245,220,194);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  font-family: "SourceHanSansCN-Medium";
  font-size: 14px;
  color: black;
  letter-spacing: 0;
  line-height: 12px;
  padding: 8px;
  right: 10%;
  top: 5px;
}
.table_top {
  background: #9a3231;
  color: #fff;
  border-radius: 20px 0 0 20px;
  line-height: 40px;
  height: 80px;
}
.table_mid {
  color: #fff;
  background: #ba4d4c;
  border-radius: 20px 0 0 20px;
  line-height: 40px;
  height: 80px;
}
.table_bot {
  color: #fff;
  background: #d58a89;
  border-radius: 20px 0 0 20px;
  line-height: 40px;
  height: 80px;
}
.sanjiao {
  z-index: 6;
  position: absolute;
  width: 35px;
  height: 20px;
  background-size: cover;
  background-image: url("../../assets/jpg/triangle.png");
  position: absolute;
  left: 50%;
  bottom: -20%;
  transform: translate(-50%, -50%);
}
.industry_footAct {
  position: relative;
  background-color: #f6e7d4 !important;
  border: 3px solid #d9b17e !important;
  box-shadow: 0 5px 25px 0 rgba(122, 81, 32, 0.3);
}
.BrandSel {
  border: 1px solid #ccc;
  z-index: 5;
  background: #faf1e7;
  box-shadow: 0 3px 20px 0 rgba(192, 168, 139, 0.3);
  border-radius: 10px;
  min-width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "SourceHanSansCN-Light";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
  line-height: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 10px;
}
.headFileitem {
  width: 100%;
  overflow: scroll;
  display: flex;
}
.headerFiltle {
  background: #faf1e7;
  padding: 20px 0;
  margin-bottom: 10px;
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
/deep/.el-input__inner {
  background: rgb(89, 91, 102) !important;
}
/deep/ .el-input .el-input__inner {
  background: #faf1e7 !important;
}
.headerHistory {
  top: 15px;
  position: relative;
  height: 66px;
  background-color: #fff;
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  align-items: center;
}
.headerHistory span {
  margin: auto 10px;
  font-family: "SourceHanSansCN-Bold";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
}
.history_tie {
  padding: 0px 5px;
  display: inline-block;
  height: 25px;
  line-height: 25px;
  min-width: 80px;
  text-align: center;
  overflow-y: scroll;
  background: #fff8f1;
  border-radius: 13px;
}
.history_Active {
  background: #f6e7d4;
}
.conTit {
  margin-left: 8%;
  display: flex;
  align-items: center;
  height: 20px;
  width: 100%;
  position: relative;
}
.conTit span {
  height: 13px;
  width: 5px;
  display: inline-block;
  background: #555555;
  border-radius: 3.5px;
  margin-right: 10px;
}
.conTit p {
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
.conTitAb {
  width: 130px;
  position: absolute;
  right: 23px;
  line-height: 21px;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.conTitAb b {
  font-family: "SourceHanSansCN-ExtraLight";
  font-size: 14px;
  color: #484781;
  letter-spacing: 0;
  text-align: center;
  line-height: 29px;
}
.conTitAbAct {
  font-family: "SourceHanSansCN-Bold";
  color: #494949 !important;
  border-bottom: 2px solid #494949;
}

.ConsumerPer {
  display: flex;
  align-items: center;
  height: 80px;
  overflow-x: scroll;
}
.ConsumerPer_act {
  background: #f6e7d4;
  border: 3px solid #d9b17e;
  box-shadow: 0 5px 25px 0 rgba(122, 81, 32, 0.3);
  border-radius: 34px;
}
.ConsumerPer span {
  height: 40px;
  min-width: 80px;
  line-height: 40px;
  text-align: center;
  margin: 0 5px;
  box-shadow: 0 3px 8px 0 rgba(231, 231, 249, 0.8);
  background: #faf1e7;
  border-radius: 34px;
  font-family: "PingFangSC-Regular";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
}
.StyleList {
  padding: 10px 0;
  min-height: 175px;
  max-height: 175px;
}
.StyleList ul {
  overflow-x: scroll;
  overflow-y: hidden;
  min-height: 200px;
  max-height: 200px;
  display: flex;
}
.listItem {
  min-width: 23%;
  max-width: 23%;
  height: 120px;
  box-shadow: 0 7px 7px rgba(0, 0, 0, 0.1);
  margin: 10px 10px;
  padding: 10px;
  text-align: center;
  background: #faf1e7;
  box-shadow: 0 5px 20px 0 rgba(175, 151, 123, 0.5);
  border-radius: 20px;
}
.listItem span {
  font-family: "PingFangSC-Light";
  font-size: 14px;
  color: #555555;
  text-align: center;
}

.listItemRate {
  display: flex;
}
.listItemIcon {
  color: #fff;
  padding: 2px;
  border-radius: 50%;
  background: rgb(89, 91, 102);
  text-align: center;
  margin-right: 5px;
}
.SkuTable {
  margin-top: 20px;
}
.SkuTable li {
  box-sizing: border-box;
  width: 100%;
  background: #faf1e7;
  box-shadow: 0 5px 20px 0 rgba(175, 151, 123, 0.5);
  border-radius: 20px;
  margin: 10px 0;
}
.SkuTable li .SkuTableOrder {
  line-height: 40px;
  height: 80px;
  background: #9a3231;
  border-radius: 20px 0 0 20px;
}
.SkuTableList {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 40px;
}
.SkuTableList span {
  font-family: "SourceHanSansCN-Normal";
  font-size: 14px;
  color: #5d5d5d;
  letter-spacing: 0;
}

.listMoney {
  display: flex;
  flex-direction: column;
  margin: 10px auto;
}
.listMoney h4 {
  font-family: "Arial-BoldMT";
  font-size: 22px;
  color: #555555;
  letter-spacing: 0;
  text-align: center;
  line-height: 22px;
  margin-bottom: 5px;
}
.listMoney p {
  font-family: "PingFangSC-Light";
  font-size: 12px;
  color: #555555;
  text-align: center;
}
.industry span {
  line-height: 21px;
  font-weight: bold;
  font-family: "STYuanti-SC-Bold";
  font-size: 16px;
  color: #595b66;
}
.main {
  padding: 10px;
  margin-top: 80px;
}

.industry {
  display: flex;
  height: 40px;
  align-items: center;
  margin: 15px;
}
.industry_tie {
  box-shadow: inset 0 7px 7px rgba(0, 0, 0, 0.1);
  margin-left: 10px;
  display: flex;
  width: 140px;
  justify-content: space-around;
  border-radius: 20px;
  height: 30px;
  background: rgb(231, 231, 249);
  padding: -1px;
  border: 1px solid rgb(231, 231, 249);
}
.industry_tie span {
  display: inline-block;
  height: 100%;
  border-radius: 15px;
  line-height: 30px;
  width: 70px;
  text-align: center;
}
.industry_tieAct {
  text-align: center;
  background: #fff;
  width: 100%;
  height: 100%;
  box-shadow: 0 7px 15px rgba(0, 0, 0, 0.1);
}
.listSel2,
.listSel {
  width: 40%;
  display: flex;
  align-items: center;
  font-family: "SourceHanSansCN-Normal";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  line-height: 14px;
}
.MylistSel {
  width: 50%;
}
.MylistSel2 {
  width: 50%;
}
.MylistSel2 .van-dropdown-menu {
  width: 50% !important;
}
.MylistSel .van-dropdown-menu {
  width: 50% !important;
}
.MylistSel .van-dropdown-menu /deep/ .van-popup--top {
  width: 27% !important;
  left: 21.5% !important;
}
.MylistSel2 .van-dropdown-menu /deep/ .van-popup--top {
  width: 27% !important;
  left: 21.5% !important;
}

.listSel2 .van-dropdown-menu {
  z-index: 7;
  background: #f9f6f2;
  border: 1px solid #555555;
  border-radius: 15px;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  width: 40%;
  height: 20px;
  position: relative;
  left: 10px;
}

.listSel .van-dropdown-menu {
  z-index: 7;
  background: #f9f6f2;
  border: 1px solid #555555;
  border-radius: 15px;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  width: 40%;
  height: 20px;
  position: relative;
  left: 10px;
}
.listSel .van-dropdown-menu /deep/ .van-popup--top {
  width: 15%;
  background: rgba(175, 151, 123, 0.9);
  border-radius: 5%;
  top: 4px;
  left: 17.5% !important;
}

.listSel2 .van-dropdown-menu /deep/ .van-popup--top {
  width: 15%;
  background: rgba(175, 151, 123, 0.9);
  border-radius: 5%;
  top: 4px;
  left: 49.5% !important;
}
/deep/ .van-cell__value {
  display: none;
}
/deep/ .van-cell__title {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #ffffff;
}
/deep/ .van-cell {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-ellipsis {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #555555;
}
/deep/ .van-dropdown-menu__title::after {
  text-align: right;
  border-color: transparent transparent #555555 #555555;
}
/deep/ .van-dropdown-item__content {
  max-height: 55%;
}
/deep/ .van-dropdown-menu__bar{
  height: 100%;
  background:  none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ButFo_Radar/Consumer_Radar.vue